import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import FAQ from './components/FAQ';
import Inquiries from './components/Inquiries';
import useAuth from '../../hooks/useAuth';


export default function CustomerService() {
  const [authInitialized, authUser] = useAuth()
  const [tab, setTab] = useState(0)
  const [plan, setPlan] = useState(null);
  const navigate = useNavigate();

  const handleNext = () => {
    sessionStorage.setItem('plan', plan);
    navigate('/plan_confirmation');
  };

  if (!authInitialized) return <div>Loading...</div>

  return (
    <ScreenContainer style={style.container}>
      <Header />
      {authUser ? <>
        <div style={style.top}>
          <h1 className={"title title_m_24_medium"} style={{ paddingLeft: 16, paddingRight: 16 }}>고객센터</h1>

          <div style={style.tab}>
            <Button
              text={"FAQ"}
              style={tab == 0 ? { ...style.tabItem, ...style.tabItemOn } : style.tabItem}
              onClick={() => setTab(0)}
            />
            <Button
              text={"문의하기"}
              style={tab == 1 ? { ...style.tabItem, ...style.tabItemOn } : style.tabItem}
              onClick={() => setTab(1)}
            />
          </div>

        </div>
        {tab == 0 ?
          <FAQ /> : <Inquiries />
        }
      </>
        :
        <div className="screen" style={{ color: "#fff", padding: 20, width: '100%' }}>
          <h1 className={"title title_m_24_medium"}>아이어리 고객센터</h1>
          <br/>
          <p>
            <b>이메일:</b> cs@edenlx.com<br /><br />
            <b>전화:</b> 1661-8171<br />
            월 ~ 금 AM 10:00 - PM 5:00<br />
            (점심시간 PM 12:00 - PM 1:00)<br />
          </p>
          <br /><br />
          <strong>COMPANY INFO</strong>
          <p>
            상호/대표자명 : 주식회사 에덴룩스/박성용 전화 : 1661-8171 사업자 등록번호 안내 : [174-81-00450] 통신판매업 신고 : 제 2016-창원성산-0063 호<br />
            개인정보관리책임자 : 주식회사 에덴룩스이메일 : cs@edenlx.com 주소 : 경상남도 창원시 성산구 전기의길 12, 신재생에너지연구동 202호<br />
            입금계좌 : IBK 기업은행 666-037162-04-031 Contact cs@edenlx.com for more information.Copyright © 2022 (주)에덴룩스. All rights reserved. <br /><br />

            ※ 무단 복제나 도용은 저작권법(97조 5항)에 의해 금지되어 있습니다. 제작물의 저작권은 당사에 있으며 위반시 처벌됩니다.<br />
          </p>


        </div>}

    </ScreenContainer>

  );
}

const style = {
  container: {
    height: '100vh',
    overflow: 'hidden',
  },
  scrollContainer: {
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  top: {
    width: '100%'
  },
  card: {
    backgroundColor: '#111D22',
    border: '1px solid transparent',
    borderRadius: 13,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',

  },
  cardOn: {
    backgroundColor: '#071A21',
    border: `1px solid ${colors.secondaryColor500}`
  },
  cardContent: {
    color: '#fff',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: 16
  },
  freeTrial: {
    color: colors.mono300
  },
  subtitle: {
    ...typography.body['14_regular'],
    color: colors.mono300,
    width: '100%',
    marginBottom: 10
  },
  cardTitle: {
    ...typography.title.s_18_medium,
    color: '#FFF',
  },
  btn: {
    ...typography.body['15_regular'],
    color: colors.white,
    width: '100%',
    justifyContent: 'space-between',
    paddingTop: 16,
    paddingBottom: 16,
    borderTop: `1px solid ${colors.surfaceBorderColor}`,
    borderRadius: 0,
    paddingLeft: 16,
    paddingRight: 20
  },
  tab: {
    display: 'flex',
    width: '100%',
    marginTop: 16
  },
  tabItem: {
    ...typography.body['15_regular'],
    color: colors.mono300,
    flex: 0.5,
    height: 40,
    borderBottom: `1px solid ${colors.surfaceBorderColorMono}`,
    borderRadius: 0
  },
  tabItemOn: {
    color: colors.white,
    borderBottom: `1px solid ${colors.mono300}`,
  }
}